// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1XS_S","left":"styles_left__3xAaS"};